// Affichage en français des valeurs techniques venant de la base (statuts, types de biens, moyens de paiement…).
// Un texte affiché qui est EXACTEMENT l'une de ces valeurs (ex. « PENDING », « Building », « Partially occupied »)
// est remplacé par son libellé français. Le reste du texte n'est jamais modifié.
import { getLanguage } from './i18n';

const BASE = {
  // Statuts généraux
  PENDING: 'En attente', PENDING_APPROVAL: 'En attente de validation', PENDING_OWNER_APPROVAL: 'En attente du propriétaire',
  PENDING_SIGNATURE: 'En attente de signature', APPROVED: 'Validé', VALIDATED: 'Validé', REJECTED: 'Refusé', REFUSED: 'Refusé',
  CANCELLED: 'Annulé', CANCELED: 'Annulé', CONFIRMED: 'Confirmé', SUCCEEDED: 'Réussi', SUCCESS: 'Réussi', FAILED: 'Échec',
  ACTIVE: 'Actif', INACTIVE: 'Inactif', ARCHIVED: 'Archivé', DRAFT: 'Brouillon', SUBMITTED: 'Soumis', OPEN: 'Ouvert', CLOSED: 'Clôturé',
  IN_PROGRESS: 'En cours', PROCESSING: 'En cours de traitement', COMPLETED: 'Terminé', DONE: 'Terminé', RESOLVED: 'Résolu',
  ASSIGNED: 'Assigné', UNASSIGNED: 'Non assigné', SCHEDULED: 'Planifié', QUEUED: 'En file d’attente', SENT: 'Envoyé', DELIVERED: 'Livré',
  SIGNED: 'Signé', EXPIRED: 'Expiré', TERMINATED: 'Résilié', SUSPENDED: 'Suspendu', TRIAL: 'Essai', BLOCKED: 'Bloqué',
  // Loyers et paiements
  PAID: 'Payé', UNPAID: 'Impayé', PARTIAL: 'Partiel', PARTIALLY_PAID: 'Payé en partie', PAID_IN_ADVANCE: 'Payé d’avance',
  UPCOMING: 'À venir', OVERDUE: 'En retard', LATE: 'En retard', DUE: 'À payer', REFUNDED: 'Remboursé', HELD: 'Conservée',
  CASH: 'Espèces', BANK_TRANSFER: 'Virement bancaire', TRANSFER: 'Virement', CHEQUE: 'Chèque', CHECK: 'Chèque', CARD: 'Carte bancaire',
  MOBILE_MONEY: 'Mobile Money', ORANGE_MONEY: 'Orange Money', MTN_MONEY: 'MTN MoMo', MOOV_MONEY: 'Moov Money', WAVE: 'Wave',
  ADVANCE_SETTLEMENT: 'Imputation d’avance', AGENCY: 'Agence', DIRECT_OWNER: 'Directement au propriétaire', OWNER: 'Propriétaire', TENANT: 'Locataire',
  // Biens et logements
  AVAILABLE: 'Disponible', OCCUPIED: 'Occupé', VACANT: 'Libre', RESERVED: 'Réservé', RENTED: 'Loué', SOLD: 'Vendu', FOR_SALE: 'À vendre',
  FOR_RENT: 'À louer', RENT: 'Location', SALE: 'Vente', MAINTENANCE: 'En travaux', UNAVAILABLE: 'Indisponible', PUBLISHED: 'Publié',
  BUILDING: 'Immeuble', APARTMENT: 'Appartement', VILLA: 'Villa', HOUSE: 'Maison', STUDIO: 'Studio', DUPLEX: 'Duplex', OFFICE: 'Bureau',
  SHOP: 'Magasin', STORE: 'Magasin', LAND: 'Terrain', WAREHOUSE: 'Entrepôt', COMMERCIAL: 'Local commercial', RESIDENTIAL: 'Résidentiel',
  PARTIALLY_OCCUPIED: 'Partiellement occupé', FULLY_OCCUPIED: 'Entièrement occupé',
  // Priorités
  URGENT: 'Urgente', HIGH: 'Haute', MEDIUM: 'Normale', NORMAL: 'Normale', LOW: 'Basse',
  // Divers
  YES: 'Oui', NO: 'Non', NONE: 'Aucun', UNKNOWN: 'Non précisé', OTHER: 'Autre', MONTHLY: 'Mensuel', YEARLY: 'Annuel', QUARTERLY: 'Trimestriel',
  MOVE_IN: 'Entrée', MOVE_OUT: 'Sortie', ENTRY: 'Entrée', EXIT: 'Sortie'
};

// Phrases et libellés anglais isolés (comparaison sans tenir compte de la casse)
const PHRASES = {
  'partially occupied': 'Partiellement occupé', 'fully occupied': 'Entièrement occupé', 'not occupied': 'Libre',
  'in progress': 'En cours', 'on hold': 'En pause', 'not started': 'Non démarré', 'pending approval': 'En attente de validation',
  'no data': 'Aucune donnée', 'no data available': 'Aucune donnée', 'loading...': 'Chargement…', 'loading': 'Chargement…',
  'unassigned': 'Non assigné', 'n/a': '—', 'view': 'Voir', 'edit': 'Modifier', 'delete': 'Supprimer', 'save': 'Enregistrer',
  'cancel': 'Annuler', 'close': 'Fermer', 'submit': 'Envoyer', 'send': 'Envoyer', 'sending...': 'Envoi…', 'search': 'Rechercher',
  'search...': 'Rechercher…', 'download': 'Télécharger', 'export': 'Exporter', 'details': 'Détails', 'actions': 'Actions',
  'status': 'Statut', 'amount': 'Montant', 'name': 'Nom', 'phone': 'Téléphone', 'address': 'Adresse', 'tenant': 'Locataire',
  'owner': 'Propriétaire', 'property': 'Bien', 'properties': 'Biens', 'unit': 'Logement', 'units': 'Logements', 'building': 'Immeuble',
  'apartment': 'Appartement', 'office': 'Bureau', 'shop': 'Magasin', 'house': 'Maison', 'land': 'Terrain', 'lease': 'Contrat de bail',
  'leases': 'Contrats de bail', 'payment': 'Paiement', 'payments': 'Paiements', 'expense': 'Dépense', 'expenses': 'Dépenses',
  'revenue': 'Revenus', 'income': 'Revenus', 'balance': 'Solde', 'invoice': 'Facture', 'quote': 'Devis', 'quotes': 'Devis',
  'overview': 'Vue d’ensemble', 'dashboard': 'Tableau de bord', 'settings': 'Paramètres', 'reports': 'Rapports', 'report': 'Rapport',
  'total': 'Total', 'yes': 'Oui', 'no': 'Non', 'all': 'Tous', 'active': 'Actif', 'inactive': 'Inactif', 'available': 'Disponible',
  'occupied': 'Occupé', 'vacant': 'Libre', 'paid': 'Payé', 'unpaid': 'Impayé', 'overdue': 'En retard', 'pending': 'En attente',
  'approved': 'Validé', 'rejected': 'Refusé', 'completed': 'Terminé', 'cancelled': 'Annulé', 'confirmed': 'Confirmé',
  'draft': 'Brouillon', 'urgent': 'Urgente', 'high': 'Haute', 'medium': 'Normale', 'low': 'Basse', 'normal': 'Normale',
  'previous': 'Précédent', 'next': 'Suivant', 'back': 'Retour', 'add': 'Ajouter', 'create': 'Créer', 'update': 'Mettre à jour',
  'filter': 'Filtrer', 'filters': 'Filtres', 'reset': 'Réinitialiser', 'confirm': 'Confirmer', 'success': 'Réussi', 'error': 'Erreur',
  'direct owner': 'Payé directement au propriétaire', 'tenant payment': 'Paiement de locataire', 'owner payment': 'Reversement au propriétaire',
  'salary payment': 'Paiement de salaire', 'lease contract': 'Contrat de bail', 'maintenance task': 'Tâche d’intervention', 'maintenance request': 'Demande d’intervention',
  'not paid': 'Non payé', 'pending director approval': 'En attente de la direction', 'pending owner signature': 'En attente de la signature du propriétaire',
  'pending management signature': 'En attente de la signature de la direction', 'pending signature': 'En attente de signature', 'for sell': 'À vendre',
  'move-in': 'Entrée', 'move-out': 'Sortie', 'cash': 'Espèces', 'bank transfer': 'Virement bancaire', 'mobile money': 'Mobile Money', 'refunded': 'Remboursé', 'expired': 'Expiré', 'terminated': 'Résilié', 'scheduled': 'Planifié', 'assigned': 'Assigné', 'resolved': 'Résolu', 'archived': 'Archivé', 'signed': 'Signé', 'partial': 'Partiel', 'late': 'En retard', 'reserved': 'Réservé', 'rented': 'Loué', 'sold': 'Vendu', 'sale': 'Vente', 'rent': 'Location', 'for rent': 'À louer', 'for sale': 'À vendre'
};

/** Libellé français d'une valeur technique ; la valeur d'origine si elle n'est pas connue. */
export function frLabel(value) {
  const raw = String(value ?? '').trim();
  if (!raw) return value;
  const key = raw.toUpperCase().replace(/[\s-]+/g, '_');
  // Codes techniques (en majuscules : PENDING, FOR_RENT…) ; un mot français comme « Commercial » n'est jamais remplacé
  if (BASE[key] && /^[A-Z_\s-]+$/.test(raw)) return BASE[key];
  return PHRASES[raw.toLowerCase()] || value;
}

const SKIP = new Set(['SCRIPT', 'STYLE', 'TEXTAREA', 'INPUT', 'CODE', 'PRE']);

function translateNode(node) {
  if (node.nodeType !== 3) return;
  const parent = node.parentNode;
  if (!parent || SKIP.has(parent.nodeName) || parent.isContentEditable || parent.closest?.('[data-no-translate]')) return;
  const text = node.nodeValue;
  const trimmed = text.trim();
  if (!trimmed || trimmed.length > 40 || !/[A-Za-z]/.test(trimmed)) return;
  const fr = frLabel(trimmed);
  if (fr && fr !== trimmed) node.nodeValue = text.replace(trimmed, fr);
}

function walk(root) {
  if (root.nodeType === 3) { translateNode(root); return; }
  if (root.nodeType !== 1 || SKIP.has(root.nodeName)) return;
  const it = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  for (let n = it.nextNode(); n; n = it.nextNode()) translateNode(n);
}

let observer = null;
/** Active la traduction à l'affichage (langue française uniquement). */
export function installFrDisplay() {
  if (observer || typeof window === 'undefined' || typeof MutationObserver === 'undefined') return;
  const start = () => {
    if (getLanguage() !== 'fr') return;
    walk(document.body);
    observer = new MutationObserver((mutations) => {
      if (getLanguage() !== 'fr') return;
      for (const m of mutations) {
        if (m.type === 'characterData') translateNode(m.target);
        else m.addedNodes.forEach(walk);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  };
  if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
}
